import React from 'react';
import { Link } from 'react-router-dom';

const SmsOptInScreenshot = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-6 px-4 sm:py-12 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Screenshot of Opt-in Form
          </h1>
          <p className="text-gray-700 text-lg">
            This is page 3 of our App Registration Form available at:{' '}
            <Link
              to="/alumni/register"
              className="text-blue-600 hover:text-blue-500 underline"
            >
              nacme.app/alumni/register
            </Link>
          </p>
        </div>

        <div className="bg-white shadow-lg rounded-lg p-6 sm:p-8">
          <img
            src="/opt-in_form.jpg"
            alt="SMS Opt-in Form - Page 3 of NACME Alumni Network Registration"
            className="w-full h-auto rounded-lg border border-gray-200"
          />
        </div>
      </div>
    </div>
  );
};

export default SmsOptInScreenshot;
